import React from 'react';
import { BASEURL, fileExportUrl } from "@api/baseUrl"
import { Button, Drawer, message, Modal, Upload, Form, Space } from "antd"
import { useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { columnsFn } from "./data"
import ProTable, { ActionType } from "@ant-design/pro-table"
import { checkGetCardOperatorList } from '@api/product';
import { ExcelAccept, productApi } from '@utils/util';
import { PROCODE_BANKCARDADDRESS } from '@utils/enum';
import { ExportButton } from '@components/index';
import { bankCardInfo } from "@api/product/identityCheck";
import ProForm, { ProFormText } from "@ant-design/pro-form";
import { ExclamationCircleOutlined, UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import type {UploadFile} from "antd/es/upload/interface";
import {useExcelUploadCheck} from "@components/MyProduct/Common/useExcelUploadCheck";
import {ExcelUploadPanel} from "@components/MyProduct/Common/ExcelUploadPanel";

// 接口请求的 api 层
const getApi = productApi(checkGetCardOperatorList)

// 在线发送
export default () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const formRef = useRef()
    const otherParams = { productCode: PROCODE_BANKCARDADDRESS }
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
    const [modalProps, setModalProps] = useState({ visible: false, title: '新增', params: {} })
    const ref = useRef<ActionType>(null);

    const operate = async (type: any, record: any) => {
        // operate 函数为增删改查需要处理的业务
    }

    const getListApi = async (params: any, sorter: any, filter: any) => {
        const { data } = await getApi({ ...params }, false)
        const { values, total } = data || {}
        return {
            data: values || [],
            success: true,
            total
        }
    }

    const columns = columnsFn(operate)
    const getQueryParams = () => ({
        // @ts-ignore
        ...formRef.current?.getFieldsFormatValue(),
        ...otherParams
    })

    const onSuccess = () => {
        console.log('处理后的成功回调触发了')
        reFresh()
    }

    const reFresh = () => {
        // @ts-ignore
        ref.current?.clearSelected()
        ref.current?.reload()
    }

    const [uploadVisible, setUploadVisible] = useState(false);


    const OnlineRequest = ({ onOk }: { onOk?: () => void }) => {
        const [form] = Form.useForm();
        const {
            fileList,
            loading,
            customRequest,
            startCheck,
            removeFile,
            finalDisabled,
        } = useExcelUploadCheck({
            request: bankCardInfo,
            onSuccess: () => {
                onOk?.();
                reFresh();
            },
        });

        const CustomSubmitter = () => (
            <div style={{ textAlign: 'center', marginTop: 24 }}>
                <Button
                    type="primary"
                    size="large"
                    style={{ width: 200 }}
                    onClick={startCheck}
                    loading={loading}
                    disabled={!finalDisabled}
                >
                    开始验证
                </Button>

                <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
                    {fileList.length ? '文件已准备就绪' : '请先上传Excel文件'}
                </div>
            </div>
        );

        const realFile = fileList?.[0]?.originFileObj as File | undefined;
        return (
            <div style={{ padding: '0 20px' }}>
                <ProForm
                    form={form}
                    layout="horizontal"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                    submitter={{
                        render: () => <CustomSubmitter />
                    }}
                    initialValues={{}}
                >
                    {/* 下载模板链接 */}
                    <ProForm.Item
                        label="模板下载"
                        style={{ marginBottom: 24 }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <a
                                href={fileExportUrl('product/银行卡归属地模板.xlsx')}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                    color: '#1890ff',
                                    textDecoration: 'none'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                            >
                                <Space>
                                    <DownloadOutlined  />
                                    <span>下载银行卡归属地模板</span>
                                </Space>
                            </a>
                            <span style={{ fontSize: 12, color: '#999' }}>
                                请按照模板格式填写数据
                            </span>
                        </div>
                    </ProForm.Item>
                    <ProForm.Item
                        label="Excel文件"
                        name="excelFile"
                        rules={[{ required: true, message: '请上传Excel文件' }]}
                        validateStatus={fileList.length ? 'success' : 'error'}
                        help={!fileList.length ? '请上传有效的Excel文件' : ''}
                    >
                        <ExcelUploadPanel
                            fileList={fileList}
                            realFile={realFile}
                            onUpload={customRequest}
                            onRemove={removeFile}
                        />
                    </ProForm.Item>
                </ProForm>

                {/* 使用说明 */}
                <div style={{
                    marginTop: 24,
                    padding: 16,
                    border: '1px solid #e8e8e8',
                    borderRadius: 6,
                    backgroundColor: '#f9f9f9'
                }}>
                    <div style={{ fontWeight: 'bold', marginBottom: 12, color: '#333' }}>
                        使用说明
                    </div>
                    <div style={{ fontSize: 13, lineHeight: 1.8, color: '#666' }}>
                        <div>📄 <strong>Excel文件上传模式：</strong></div>
                        <div>1. 点击“下载银行卡归属地模板”下载Excel模板文件</div>
                        <div>2. 按照模板格式填写银行卡号等需要核验的信息</div>
                        <div>3. 点击“选择Excel文件”上传填写好的Excel文件</div>
                        <div>4. 支持 .xls、.xlsx 格式，单个文件最大 1MB</div>
                        <div>5. 上传后可预览文件信息，可随时移除重新上传</div>
                        <div style={{ marginTop: 12 }}>
                            ⚠️ <strong>重要注意事项：</strong>
                        </div>
                        <div>• 请正确填写信息，如银行卡号等，否则会导致识别失败</div>
                        <div>• Excel数据上限为1000条，超过请分批识别</div>
                        <div>• 请不要修改Excel的表头，否则会导致验证失败</div>
                        <div>• 提交成功后，识别信息会显示在调用明细中</div>
                        <div>• 可在表格中查看历史记录并导出结果</div>
                        <div>• 该调用会产生一定费用,请确认余额充足</div>
                    </div>
                </div>

                {/* 底部提示 */}
                <div style={{
                    marginTop: 16,
                    padding: 12,
                    border: '1px dashed #91d5ff',
                    borderRadius: 6,
                    backgroundColor: '#e6f7ff'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', color: '#1890ff' }}>
                        <span style={{ marginRight: 8 }}>💡</span>
                        <span style={{ fontSize: 13 }}>
                            建议使用最新版本的Excel软件编辑模板，避免格式兼容性问题
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <ProTable<any>
                style={{ flex: 1, overflow: 'scroll' }}
                scroll={{ x: 1300 }}
                columns={columns}
                params={otherParams}
                request={getListApi}
                formRef={formRef as any}
                options={{ reload: false, density: false, setting: false }}
                toolbar={{
                    actions: [
                        <ExportButton
                            key="export"
                            type='primary'
                            action={`${BASEURL}/web/product/exportCardOperatorList`}
                            param={getQueryParams}
                            btnText="导出"
                        />,
                        <Button
                            key="online"
                            type="primary"
                            onClick={() => setUploadVisible(true)}
                            style={{ marginLeft: 8 }}
                        >
                            <Space>
                                <span>在线验证</span>
                            </Space>
                        </Button>,
                    ],
                }}
                rowKey="tiId"
                pagination={{ defaultPageSize: 10, showSizeChanger: true, showQuickJumper: true }}
                actionRef={ref as any}
                search={{
                    optionRender: (searchConfig, formProps, dom) => [...dom.reverse()]
                }}
            />
            <Drawer
                title={
                    <Space>
                        <UploadOutlined />
                        <span style={{ fontSize: 16, fontWeight: 'bold' }}>银行卡归属地验证</span>
                    </Space>
                }
                open={uploadVisible}
                width={800}
                onClose={() => {
                    setUploadVisible(false);
                }}
                destroyOnClose
            >
                <OnlineRequest
                    onOk={() => {
                        setUploadVisible(false);
                        setTimeout(() => {
                            reFresh();
                        }, 1000);
                    }}
                />
            </Drawer>
        </>
    );
}